export const IconesPorModalidade = {
  '1': 'mdi-home-city',
  '2': 'mdi-motorbike',
  '3': 'mdi-certificate',
  '4': 'mdi-car-side',
  '5': 'mdi-truck',
  '6': 'mdi-dump-truck',
  '7': 'mdi-tractor-variant',
  'default': 'rod-carrinho'
}
export const IconesPorProduto = {
  // imoveis
  '1': IconesPorModalidade['1'],
  '21': IconesPorModalidade['1'],
  // motocicletas
  '10': IconesPorModalidade['2'],
  '22': IconesPorModalidade['2'],
  // servicos
  '11': IconesPorModalidade['3'],
  // automoveis
  '2': IconesPorModalidade['4'],
  '3': IconesPorModalidade['4'],
  '14': IconesPorModalidade['4'],
  '15': IconesPorModalidade['4'],
  '16': IconesPorModalidade['4'],
  // caminhoes
  '28': IconesPorModalidade['5'],
  '4': IconesPorModalidade['5'],
  '5': IconesPorModalidade['5'],
  '6': IconesPorModalidade['5'],
  '7': IconesPorModalidade['5'],
  '23': IconesPorModalidade['5'],
  '17': IconesPorModalidade['5'],
  '29': IconesPorModalidade['5'],
  '30': IconesPorModalidade['5'],
  '31': IconesPorModalidade['5'],
  // implementos_rodoviarios
  '8': IconesPorModalidade['6'],
  '26': IconesPorModalidade['6'],
  // maquinas
  '25': IconesPorModalidade['7'],
  '24': IconesPorModalidade['7'],
  'default': IconesPorModalidade['default']
}
